import { PrimaryButton } from "@cadmakers-ui/core";
import { Icon } from "@cadmakers-ui/icons";
import React, { useState } from "react";
import { Feedback } from "../../..";
import { IAppState } from "../../../../Common";
import FeedbackAssignmentModal from "./FeedbackAssignmentModal";
import styles from "../../../Styles/FeedbackAssignmentsDisplay.module.scss";
import AuthorProfileBadge from "../../../../User/Components/Common/AuthorProfileBadge";
import { AuthorType } from "../../../../User/Constants/userEnums";
import { User } from "../../../../User";
import { useLoggedInUser } from "../../../../Auth";

type Props = {
  feedback: Feedback;
  displayVertical?: boolean;
  onSaveChanges: (selectedUsers: User[]) => void;
};

const FeedbackAssignmentsDisplay: React.FC<Props> = props => {
  const [isOpen, setIsOpen] = useState(false);

  const user = useLoggedInUser();

  if (
    !user ||
    !user.profile.companyName ||
    user.profile.companyName.toLowerCase() !== "cadmakers"
  ) {
    return <></>;
  }

  const onSaveChanges = (selectedUsers: User[]) => {
    setIsOpen(false);
    props.onSaveChanges(selectedUsers);
  };

  const onClickEditUsers = (e: React.MouseEvent) => {
    setIsOpen(true);

    e.stopPropagation();
  };

  return (
    <>
      <div>
        {props.feedback.assignedTo.map((u, i) => (
          <>
            {props.displayVertical && i > 0 && <br />}
            <span className={styles.userSpan}>
              <AuthorProfileBadge
                authoredBy={{ id: u.username, name: u.name, type: AuthorType.User }}
              />
            </span>
          </>
        ))}
        {props.feedback.assignedTo.length === 0 && (
          <span className={styles.noUsersAssigned}>Unassigned</span>
        )}
        {props.feedback.permissions && props.feedback.permissions.canAssignUser && (
          <>
            <Icon
              appName="GeneralLayout"
              assetName="POINTER_AddAnchor"
              onClick={onClickEditUsers}
              className={styles.editIcon}
              title="Edit Assigned Users"
            />
            <FeedbackAssignmentModal
              feedbackCode={props.feedback.code}
              feedbackName={props.feedback.title}
              defaultSelectedUsers={props.feedback.assignedTo.map(u => ({
                id: u.id,
                name: u.name,
                username: u.username,
                email: "" // this member is not actually used for this prop
              }))}
              isOpen={isOpen}
              toggle={() => setIsOpen(!isOpen)}
              onSaveChanges={onSaveChanges}
            />
          </>
        )}
      </div>
    </>
  );
};

export default FeedbackAssignmentsDisplay;
